// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/OperacaoCompromissos_CategoriasResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for GET /dashboards/operacao_compromissos/categorias.
 *
 * Returns the donut breakdown of realized compromissos by
 * config_servicos_categorias. One row per categoria with COUNT,
 * SUM(compromisso_servico_valor), and a [0..1] percentual of the
 * realized total.
 */
import type { OperacaoCompromissos_CategoriaRow } from './OperacaoCompromissos_CategoriaRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type OperacaoCompromissos_CategoriasResponseDados = OperacaoCompromissos_CategoriaRow[];

export type OperacaoCompromissos_CategoriasResponse = ApiResponse<OperacaoCompromissos_CategoriasResponseDados>;

registerResponseContract('OperacaoCompromissos_CategoriasResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      categoria_id:    { type: 'number',  required: true },
      categoria:       { type: 'string',  required: true },
      numero_servicos: { type: 'number',  required: false },
      total:           { type: 'number',  required: false },
      percentual:      { type: 'number',  required: false },
    },
  },
})
